<template>
  <div class="modal-klarna-overlay" @click="closeKlarnaModal">
    <div class="modal-klarna-container">
      <div class="col-12">
        <div class="row">
          <span class="col-12 modal-k-header">Klarna.</span>
          <span class="col-12 modal-text">{{ t('modal.klarna.text.1') }}</span>
          <div class="col-12 modal-semi-content">
            <div class="modal-row">
                <span class="col-12 d-flex text-left content-margin">
                  {{ t('modal.klarna.text.2') }}
                </span>
              <div class="arrow-container">
                <span class="arrow"></span>
                <span class="col-12 d-flex text-left content-margin">
                  {{ t('modal.klarna.text.3') }}
                </span>
              </div>
              <div class="arrow-container">
                <span class="arrow second-el"></span>
                <span class="col-12 text-left content-margin d-block">
                  {{ t('modal.klarna.text.4') }}
                  <img src="/ui/design/img/klarna-icon.svg" alt="Klarna icon">
                </span>
              </div>
              <div class="arrow-container">
                <span class="arrow third-el"></span>
                <span class="col-12 d-flex text-left content-margin">
                  {{ t('modal.klarna.text.5') }}
                </span>
              </div>
              <div class="arrow-container">
                <span class="arrow-last"></span>
                <span class="col-12 d-flex text-left content-margin">
                  {{ t('modal.klarna.text.6') }}
                </span>
              </div>
              <span class="col-12 text-left content-margin terms-klarna pr-0" v-html="t('modal.klarna.text.7')"></span>
            </div>
          </div>
          <span class="close-btn" @click="closeModal">{{ t('close.modal.text') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KlarnaModal',
  methods: {
    closeKlarnaModal(event) {
      if (event.target.classList.contains('modal-klarna-overlay')) {
        this.$emit('close');
      }
    },
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>


<style scoped>

.modal-klarna-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-klarna-container {
  width: 550px;
  height: auto;
  background-color: #ffffff;
  padding: 20px 0;
  border-radius: 10px;
  position: relative;
  top: 5%;
}

.close-btn {
  display: inline-block;
  padding: 8px 16px;
  background-color: #000000;
  color: #ffffff;
  cursor: pointer;
  border-radius: 4px;
  text-align: center;
  border: 2px solid #000000;
  transition: all 300ms ease-in-out;
  width: 75%;
  margin: 0 auto 1.5rem auto;
}

.close-btn:hover {
  color: #000000;
  background-color: #ffffff;
  border: 2px solid #000000;
  transition: all 300ms ease-in-out;
}

.modal-k-header {
  text-align: center;
  font-size: 28px;
  color: #989593;
  font-weight: 800;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}

.modal-text {
  color: #000000;
  font-size: 28px;
  font-weight: 700;
  text-align: center;
}

.modal-semi-content {
  color: #000000;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  display: flex;
  padding: 0;
}

.modal-row {
  display: flex;
  flex-wrap: wrap;
  width: 70%;
  margin: 0 auto;
  justify-content: flex-start;
}

.content-margin {
  margin: 15px 0;
  line-height: 1.2rem;
  padding: 0;
}

.terms-klarna {
  color: #8C8C8C;
  font-size: 12px;
  line-height: 1rem;
  margin-bottom: 1.8rem;
  margin-top: 1rem;
  padding: 0;
  font-weight: 500;
}

.arrow-container {
  position: relative;
}

.arrow-container img {
  width: 40px;
}

.arrow {
  position: absolute;
  top: 50%;
  left: -15px;
  margin-top: -5px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 0 5px 8px;
  border-color: transparent transparent transparent #989593;
}

.arrow-last {
  position: absolute;
  top: 28%;
  left: -15px;
  margin-top: -5px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 0 5px 8px;
  border-color: transparent transparent transparent #989593;
}

@media screen and (max-width: 575px) {
  .arrow-container .second-el {
    top: 35%;
  }
  .modal-text {
    font-size: 24px;
  }
  .close-btn {
    width: 80%;
  }
}

@media screen and (max-width: 380px) {
  .modal-text {
    font-size: 22px;
  }
  .modal-row {
    width: 80%;
  }
}

</style>
